/* PetalFinger · pf-base.js
   共用逻辑：购物车 API、购物车抽屉、快速加购、视频懒加载、公告轮播、标签页、
   组合进度、测验、弹窗。只加载一次（见 window.PF 守卫）。 */
(function () {
  if (window.PF) return;
  var PF = (window.PF = { cart: null, listeners: [] });
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  PF.$ = $; PF.$$ = $$;

  /* ---------- money ---------- */
  var fmt = (document.documentElement.getAttribute('data-pf-money') || '${{amount}}');
  PF.money = function (cents) {
    var n = (cents || 0) / 100;
    var out = fmt;
    var fixed = n.toFixed(2);
    var parts = fixed.split('.');
    var thousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    out = out.replace('{{amount_no_decimals_with_comma_separator}}', thousands.replace(/,/g, '.'))
      .replace('{{amount_with_comma_separator}}', thousands.replace(/,/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals}}', thousands)
      .replace('{{amount}}', thousands + '.' + parts[1]);
    return out.replace(/<[^>]+>/g, '');
  };
  PF.img = function (url, w) {
    if (!url) return '';
    url = url.replace(/^\/\//, 'https://');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  };

  /* ---------- toast ---------- */
  var toast;
  PF.toast = function (msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'pf-toast'; document.body.appendChild(toast); }
    toast.textContent = msg; toast.classList.add('is-show');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-show'); }, 1800);
  };

  /* ---------- cart api ---------- */
  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  PF.getCart = function () {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { PF.cart = c; PF.emit(c); return c; });
  };
  PF.emit = function (cart) {
    document.dispatchEvent(new CustomEvent('pf:cart', { detail: cart }));
    try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pf', cartData: cart }); } catch (e) { }
    PF.updateBubble(cart);
  };
  PF.updateBubble = function (cart) {
    var n = cart ? cart.item_count : 0;
    $$('#cart-icon-bubble, [data-pf-cart-count]').forEach(function (el) {
      var b = el.querySelector('.cart-count-bubble');
      if (el.hasAttribute('data-pf-cart-count')) { el.textContent = n || ''; return; }
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; el.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + n + '</span>';
    });
  };
  PF.add = function (items, opts) {
    opts = opts || {};
    return fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () { return PF.getCart(); })
      .then(function (cart) { if (!opts.silent) PF.openCart(); return cart; })
      .catch(function (e) { PF.toast(e.message); throw e; });
  };
  PF.change = function (key, qty) {
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { PF.cart = c; PF.emit(c); return c; });
  };
  PF.openCart = function () { var d = $('cart-drawer[data-pf]'); if (d && d.open) d.open(); else if (!d) window.location.href = cartUrl; };

  /* ---------- drawers (generic) ---------- */
  PF.openDrawer = function (el) {
    if (!el) return;
    var ov = $('.pf-overlay[data-pf-overlay]');
    if (!ov) { ov = document.createElement('div'); ov.className = 'pf-overlay'; ov.setAttribute('data-pf-overlay', ''); document.body.appendChild(ov); ov.addEventListener('click', PF.closeDrawers); }
    $$('.pf-drawer.is-open').forEach(function (d) { if (d !== el) d.classList.remove('is-open'); });
    el.classList.add('is-open'); ov.classList.add('is-open'); document.body.classList.add('pf-lock');
    el.dispatchEvent(new CustomEvent('pf:drawer-open'));
    var c = el.querySelector('.pf-drawer__close'); if (c) setTimeout(function () { c.focus(); }, 300);
  };
  PF.closeDrawers = function () {
    $$('.pf-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    var ov = $('.pf-overlay[data-pf-overlay]'); if (ov) ov.classList.remove('is-open');
    document.body.classList.remove('pf-lock');
  };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') PF.closeDrawers(); });

  /* ---------- cart drawer element (Dawn-compatible API) ---------- */
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.drawer = this.querySelector('.pf-drawer');
        this.freeShip = parseInt(this.dataset.freeShipping || '0', 10);
        this.bundleQty = parseInt(this.dataset.bundleQty || '0', 10);
        this.bundlePct = parseInt(this.dataset.bundlePct || '0', 10);
        this.upsellCollection = this.dataset.upsellCollection || '';
        this.addEventListener('click', function (e) {
          var b = e.target.closest('[data-pf-qty]');
          if (b) { self.changeQty(b.dataset.key, parseInt(b.dataset.pfQty, 10)); return; }
          var r = e.target.closest('[data-pf-remove]');
          if (r) { self.changeQty(r.dataset.key, 0); return; }
          if (e.target.closest('.pf-drawer__close')) PF.closeDrawers();
        });
        document.addEventListener('click', function (e) {
          var a = e.target.closest('#cart-icon-bubble, a[href="' + cartUrl + '"], a[href$="/cart"]');
          if (a && !e.target.closest('cart-drawer') && !a.closest('.pf-no-drawer')) { e.preventDefault(); self.open(); }
        });
        document.addEventListener('pf:cart', function (e) { self.render(e.detail); });
        PF.getCart();
      }
      /* Dawn product-form 调用的接口 */
      getSectionsToRender() { return []; }
      setActiveElement() { }
      renderContents() { var self = this; PF.getCart().then(function () { self.open(); }); }
      open() { var self = this; PF.getCart().then(function () { PF.openDrawer(self.drawer); self.classList.remove('is-empty'); }); }
      close() { PF.closeDrawers(); }
      changeQty(key, qty) {
        var row = this.querySelector('[data-key="' + key + '"]'); if (row) row.style.opacity = '.5';
        PF.change(key, qty);
      }
      render(cart) {
        var body = this.querySelector('[data-pf-cart-items]'); if (!body || !cart) return;
        var self = this;
        var sub = cart.items_subtotal_price, total = cart.total_price;
        var html = '';
        if (!cart.items.length) {
          html = '<div class="pf-cart-empty"><p>' + (this.dataset.emptyText || 'Your bag is empty.') + '</p><a class="pf-btn" href="' + (this.dataset.emptyLink || '/collections/all') + '">' + (this.dataset.emptyCta || 'Shop best sellers') + '</a></div>';
        } else {
          html = cart.items.map(function (it) {
            var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' · ');
            var price = it.final_line_price !== it.original_line_price ? '<s>' + PF.money(it.original_line_price) + '</s> ' + PF.money(it.final_line_price) : PF.money(it.final_line_price);
            return '<div class="pf-ci" data-key="' + it.key + '"><a href="' + it.url + '" class="pf-ci__img"><img src="' + PF.img(it.image, 160) + '" alt=""></a>' +
              '<div class="pf-ci__tx"><a href="' + it.url + '" class="pf-ci__name">' + it.product_title + '</a><span class="pf-ci__opt">' + opts + '</span>' +
              '<div class="pf-ci__row"><div class="pf-qty pf-qty--sm"><button type="button" data-pf-qty="' + (it.quantity - 1) + '" data-key="' + it.key + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-pf-qty="' + (it.quantity + 1) + '" data-key="' + it.key + '" aria-label="Increase">+</button></div>' +
              '<b class="pf-ci__price">' + price + '</b></div></div>' +
              '<button type="button" class="pf-ci__rm" data-pf-remove data-key="' + it.key + '" aria-label="Remove">' + PF.icon('x') + '</button></div>';
          }).join('');
        }
        body.innerHTML = html;
        /* progress bar */
        var prog = this.querySelector('[data-pf-cart-progress]');
        if (prog) {
          var count = cart.items.reduce(function (a, i) { return a + i.quantity; }, 0);
          if (this.bundleQty && this.bundlePct) {
            var k = Math.min(this.bundleQty, count);
            prog.innerHTML = '<div class="pf-ship__row">' + PF.icon('gift') + '<span>' + (k >= this.bundleQty ? '<b>' + (this.dataset.bundleDone || 'Bundle unlocked: {pct}% off').replace('{pct}', this.bundlePct) + '</b>' : (this.dataset.bundleMsg || 'Add {n} more to save {pct}%').replace('{n}', this.bundleQty - k).replace('{pct}', this.bundlePct)) + '</span></div><div class="pf-bar"><i style="width:' + (k / this.bundleQty * 100) + '%"></i></div>';
          } else if (this.freeShip) {
            var left = Math.max(0, this.freeShip - sub);
            prog.innerHTML = '<div class="pf-ship__row">' + PF.icon('truck') + '<span>' + (left <= 0 ? '<b>' + (this.dataset.shipDone || 'Free shipping unlocked ✓') + '</b>' : (this.dataset.shipMsg || "You're {amount} away from free shipping").replace('{amount}', '<b>' + PF.money(left) + '</b>')) + '</span></div><div class="pf-bar"><i style="width:' + Math.min(100, sub / this.freeShip * 100) + '%"></i></div>';
          }
          prog.hidden = !cart.items.length;
        }
        var subEl = this.querySelector('[data-pf-cart-sub]'); if (subEl) subEl.textContent = PF.money(total);
        var foot = this.querySelector('.pf-drawer__foot'); if (foot) foot.hidden = !cart.items.length;
        var cnt = this.querySelector('[data-pf-cart-title-count]'); if (cnt) cnt.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
        this.renderUpsell(cart);
      }
      renderUpsell(cart) {
        var box = this.querySelector('[data-pf-cart-upsell]'); if (!box) return;
        if (!cart.items.length && !this.dataset.upsellWhenEmpty) { box.hidden = true; return; }
        var self = this, inCart = cart.items.map(function (i) { return i.product_id; });
        var url = cart.items.length ? '/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=6&intent=complementary' : null;
        var load = url ? fetch(url).then(function (r) { return r.json(); }).then(function (j) { return j.products || []; }).catch(function () { return []; }) : Promise.resolve([]);
        load.then(function (products) {
          if (products.length < 2 && self.upsellCollection) return fetch('/collections/' + self.upsellCollection + '/products.json?limit=8').then(function (r) { return r.json(); }).then(function (j) { return j.products || []; });
          return products;
        }).then(function (products) {
          products = products.filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available !== false; }).slice(0, 3);
          if (!products.length) { box.hidden = true; return; }
          box.hidden = false;
          box.querySelector('[data-pf-upsell-list]').innerHTML = products.map(function (p) {
            var v = p.variants.filter(function (v) { return v.available !== false; });
            var img = (p.images && p.images[1] && p.images[1].src) || (p.featured_image) || (p.images && p.images[0] && p.images[0].src) || '';
            var price = (v[0] || p.variants[0]) ? PF.money(Math.round(parseFloat((v[0] || p.variants[0]).price) * 100)) : '';
            var sizes = v.map(function (x) { return '<button type="button" data-pf-variant="' + x.id + '">' + (x.option1 || x.title) + '</button>'; }).join('');
            return '<div class="pf-up"><a href="/products/' + p.handle + '"><img src="' + PF.img(img, 120) + '" alt=""></a><div class="pf-up__tx"><b>' + p.title + '</b><span>' + price + '</span></div><div class="pf-up__sizes">' + sizes + '</div></div>';
          }).join('');
        });
      }
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('cart-drawer .pf-up__sizes [data-pf-variant]');
      if (b) { b.classList.add('is-busy'); PF.add([{ id: parseInt(b.dataset.pfVariant, 10), quantity: 1 }], { silent: true }).then(function () { PF.toast('Added to bag'); }).finally(function () { b.classList.remove('is-busy'); }); }
    });
  }

  /* ---------- icons ---------- */
  var ICONS = {
    x: '<svg class="pf-ic" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    gift: '<svg class="pf-ic" viewBox="0 0 24 24"><path d="M4 11h16v9H4zM3 7.5h18V11H3zM12 7.5V20"/><path d="M12 7.5C10.5 4.5 7 4 7 6s3.5 1.5 5 1.5c1.5 0 5 .5 5-1.5s-3.5-1.5-5 1.5z"/></svg>',
    truck: '<svg class="pf-ic" viewBox="0 0 24 24"><path d="M2.5 6h11v10h-11zM13.5 9.5h4l3 3V16h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    play: '<svg viewBox="0 0 24 24"><path d="M7 4.5v15l13-7.5z"/></svg>',
    plus: '<svg class="pf-ic pf-ic--sm" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>',
    star: '<svg viewBox="0 0 24 24"><path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4L2.8 9.5l6.4-.8z"/></svg>'
  };
  PF.icon = function (n) { return ICONS[n] || ''; };

  /* ---------- quick add (product cards) ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-pf-qa-open]');
    if (open) {
      e.preventDefault(); e.stopPropagation();
      var card = open.closest('.pf-card'), qa = card && card.querySelector('.pf-qa');
      if (!qa) return;
      $$('.pf-qa.is-open').forEach(function (x) { if (x !== qa) x.classList.remove('is-open'); });
      qa.classList.toggle('is-open');
      return;
    }
    var v = e.target.closest('.pf-qa [data-pf-variant]');
    if (v) {
      e.preventDefault(); e.stopPropagation();
      var q = v.closest('.pf-qa'); q.classList.remove('is-open');
      var btn = v.closest('.pf-card').querySelector('[data-pf-qa-open]');
      if (btn) btn.classList.add('is-loading');
      PF.add([{ id: parseInt(v.dataset.pfVariant, 10), quantity: 1 }]).finally(function () { if (btn) btn.classList.remove('is-loading'); });
      return;
    }
    if (!e.target.closest('.pf-qa')) $$('.pf-qa.is-open').forEach(function (x) { x.classList.remove('is-open'); });
  });

  /* ---------- video source choice: HLS where native (iOS/Safari), SD on slow networks, 720p mp4 otherwise; fall back to the original mp4 on error ---------- */
  PF.videoSrc = function (v) {
    /* SD only when the browser says data-saver or a 2G-class link; Chrome often labels decent Wi-Fi as 3g, so 3g still gets 720p */
    var slow = false; try { var cn = navigator.connection; slow = !!(cn && (cn.saveData || /2g/.test(cn.effectiveType || ''))); } catch (e) { }
    if (slow && v.dataset.srcSd) return v.dataset.srcSd;
    /* HLS only where it plays natively (iOS / macOS Safari); other browsers get the 720p mp4 */
    var ua = navigator.userAgent, safari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|Edg|OPR/.test(ua);
    if (v.dataset.srcHls && safari) return v.dataset.srcHls;
    return v.dataset.src;
  };
  PF.videoFallback = function (vid, v) {
    vid.addEventListener('error', function () {
      var orig = v.dataset.srcOrig; if (!orig || vid.dataset.pfFallback === '1') return;
      vid.dataset.pfFallback = '1'; vid.src = orig; vid.load(); vid.play().catch(function () { });
    });
  };

  /* ---------- lazy video: poster first, load on click ---------- */
  document.addEventListener('click', function (e) {
    var v = e.target.closest('.pf-video[data-src]');
    if (!v || e.target.closest('.pf-video__shop')) return;
    if (v.closest('[data-pf-vlist]') && PF.openVideoModal(v)) return;
    if (v.classList.contains('is-playing')) return;
    $$('.pf-video.is-playing video').forEach(function (x) { x.pause(); });
    var img = v.querySelector('img');
    var vid = document.createElement('video');
    vid.src = PF.videoSrc(v); PF.videoFallback(vid, v); vid.poster = img ? img.currentSrc || img.src : ''; vid.muted = true; vid.playsInline = true; vid.autoplay = true; vid.loop = true; vid.controls = true; vid.preload = 'metadata';
    if (img) img.replaceWith(vid); else v.prepend(vid);
    v.classList.add('is-playing');
    vid.play().catch(function () { });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.pf-video__add[data-pf-variant]');
    if (a) { e.preventDefault(); e.stopPropagation(); PF.add([{ id: parseInt(a.dataset.pfVariant, 10), quantity: 1 }]); }
  });


  /* ---------- shoppable video lightbox: one video at a time, sound on, product sizes ---------- */
  function escV(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderVModal(m) {
    var v = m._items[m._i], list = m._list, vid = m.querySelector('[data-pf-vplayer]'), img = v.querySelector('img');
    vid.pause(); vid.dataset.pfFallback = ''; if (!vid.dataset.pfBound) { vid.dataset.pfBound = '1'; vid.addEventListener('error', function () { var cur = m._items[m._i]; var orig = cur && cur.dataset.srcOrig; if (!orig || vid.dataset.pfFallback === '1') return; vid.dataset.pfFallback = '1'; vid.src = orig; vid.load(); vid.play().catch(function () { }); }); }
    vid.src = PF.videoSrc(v); vid.poster = v.dataset.poster || (img ? (img.currentSrc || img.src) : ''); vid.loop = true; vid.muted = list.dataset.pfSound === 'false'; vid.load();
    var pl = vid.play(); if (pl && pl.catch) pl.catch(function () { vid.muted = true; vid.play().catch(function () { }); });
    var d = {}; try { d = JSON.parse(v.dataset.pfVdata || '{}'); } catch (e) { }
    m.classList.toggle('no-product', !d.url);
    if (d.url) {
      m.querySelector('[data-pf-vp]').href = d.url; m.querySelector('[data-pf-vlink]').href = d.url;
      m.querySelector('[data-pf-vtitle]').textContent = d.title || ''; m.querySelector('[data-pf-vprice]').textContent = d.price ? PF.money(d.price) : '';
      var im = m.querySelector('[data-pf-vimg]'); if (d.img) { im.src = d.img; im.hidden = false; } else { im.hidden = true; }
      var vs = d.variants || [], sz = m.querySelector('[data-pf-vsizes]'), hint = m.querySelector('[data-pf-vhint]');
      if (vs.length === 1) { sz.innerHTML = '<button type="button" class="pf-btn pf-btn--block" data-pf-variant="' + vs[0].id + '"' + (vs[0].a ? '' : ' disabled') + '>' + escV(list.dataset.pfAddLabel || 'Add to cart') + '</button>'; if (hint) hint.hidden = true; }
      else { sz.innerHTML = vs.map(function (x) { return '<button type="button" data-pf-variant="' + x.id + '"' + (x.a ? '' : ' disabled') + '>' + escV(x.t) + '</button>'; }).join(''); if (hint) hint.hidden = !vs.length; }
    }
    var cap = m.querySelector('[data-pf-vcap]'); if (cap) { cap.textContent = d.caption || ''; cap.hidden = !d.caption; }
    var prev = m.querySelector('[data-pf-vnav="-1"]'), next = m.querySelector('[data-pf-vnav="1"]');
    if (prev) prev.disabled = m._i <= 0; if (next) next.disabled = m._i >= m._items.length - 1;
  }
  PF.openVideoModal = function (v) {
    var list = v.closest('[data-pf-vlist]'); if (!list) return false;
    var sec = list.closest('.shopify-section') || document;
    var m = sec.querySelector('[data-pf-vmodal]') || document.querySelector('[data-pf-vmodal]'); if (!m) return false;
    m._list = list; m._items = $$('.pf-video[data-src]', list); m._i = Math.max(0, m._items.indexOf(v));
    $$('.pf-video.is-playing video').forEach(function (x) { x.pause(); });
    renderVModal(m); m.hidden = false; document.body.classList.add('pf-lock');
    var c = m.querySelector('.pf-vmodal__close'); if (c) setTimeout(function () { c.focus(); }, 50);
    return true;
  };
  PF.closeVideoModal = function () {
    var m = document.querySelector('[data-pf-vmodal]:not([hidden])'); if (!m) return;
    var vid = m.querySelector('[data-pf-vplayer]'); if (vid) { vid.pause(); vid.removeAttribute('src'); vid.load(); }
    m.hidden = true; document.body.classList.remove('pf-lock');
  };
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-pf-vmodal]'); if (!m) return;
    if (e.target.closest('[data-pf-vclose]')) { PF.closeVideoModal(); return; }
    var n = e.target.closest('[data-pf-vnav]');
    if (n) { var i = m._i + parseInt(n.dataset.pfVnav, 10); if (i >= 0 && i < m._items.length) { m._i = i; renderVModal(m); } return; }
    var b = e.target.closest('.pf-vmodal__sizes [data-pf-variant]');
    if (b && !b.disabled) { b.classList.add('is-busy'); PF.add([{ id: parseInt(b.dataset.pfVariant, 10), quantity: 1 }], { silent: true }).then(function () { PF.closeVideoModal(); PF.openCart(); }).catch(function () { b.classList.remove('is-busy'); }); }
  });
  document.addEventListener('keydown', function (e) {
    var m = document.querySelector('[data-pf-vmodal]:not([hidden])'); if (!m) return;
    if (e.key === 'Escape') PF.closeVideoModal();
    else if (e.key === 'ArrowRight' && m._i < m._items.length - 1) { m._i++; renderVModal(m); }
    else if (e.key === 'ArrowLeft' && m._i > 0) { m._i--; renderVModal(m); }
  });

  /* ---------- in-view autoplay (steps videos): play only when visible, saves data ---------- */
  var inview = $$('video[data-pf-inview]');
  if (inview.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { if (!v.dataset.loaded) { v.dataset.loaded = '1'; v.preload = 'auto'; v.load(); } v.play().catch(function () { }); } else { v.pause(); } });
    }, { threshold: .35 });
    inview.forEach(function (v) { vio.observe(v); });
  }

  /* ---------- rotating announcement ---------- */
  $$('[data-pf-rotate]').forEach(function (r) {
    var s = $$(':scope > span', r); if (s.length < 2) return;
    var k = 0, iv = parseInt(r.dataset.pfRotate, 10) || 4000;
    setInterval(function () { s[k].classList.remove('is-on'); k = (k + 1) % s.length; s[k].classList.add('is-on'); }, iv);
  });

  /* ---------- tabs ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pf-tabs] [data-tab]'); if (!t) return;
    var g = t.closest('[data-pf-tabs]');
    $$('[data-tab]', g).forEach(function (b) { b.classList.toggle('is-on', b === t); b.setAttribute('aria-selected', b === t); });
    $$('[data-panel]', g).forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
  });

  /* ---------- bundle progress widgets ---------- */
  function renderBundles(cart) {
    $$('[data-pf-bundle]').forEach(function (el) {
      var need = parseInt(el.dataset.qty, 10) || 3, pct = el.dataset.pct || '25';
      var count = cart ? cart.items.reduce(function (a, i) { return a + i.quantity; }, 0) : 0, k = Math.min(need, count);
      var msg = el.querySelector('[data-bmsg]'); if (msg) msg.textContent = k >= need ? (el.dataset.done || 'Bundle unlocked: {pct}% off ✓').replace('{pct}', pct) : (el.dataset.msg || '{k} of {n} added · add {left} more to save {pct}%').replace('{k}', k).replace('{n}', need).replace('{left}', need - k).replace('{pct}', pct);
      var bar = el.querySelector('[data-bbar]'); if (bar) bar.style.width = (k / need * 100) + '%';
      var slots = $$('[data-slots] .pf-slot', el);
      var imgs = []; (cart ? cart.items : []).forEach(function (i) { for (var q = 0; q < i.quantity; q++) imgs.push(i.image); });
      slots.forEach(function (s, i) { if (imgs[i]) { s.classList.add('is-filled'); s.innerHTML = '<img src="' + PF.img(imgs[i], 300) + '" alt="">'; } else { s.classList.remove('is-filled'); s.textContent = (el.dataset.slotLabel || 'Set') + ' ' + (i + 1); } });
    });
  }
  document.addEventListener('pf:cart', function (e) { renderBundles(e.detail); });
  if ($('[data-pf-bundle]') && !$('cart-drawer[data-pf]')) PF.getCart();

  /* ---------- quiz ---------- */
  $$('[data-pf-quiz]').forEach(function (q) {
    var ans = {}, steps = $$('.pf-q__step', q), bar = q.querySelector('[data-qbar]'), lab = q.querySelector('[data-qn]');
    function show(k) { steps.forEach(function (s, i) { s.classList.toggle('is-on', i === k); }); if (bar) bar.style.width = Math.min(100, (k + 1) / steps.length * 100) + '%'; if (lab) lab.textContent = k < steps.length - 1 ? (q.dataset.stepLabel || 'Step {k} of {n}').replace('{k}', k + 1).replace('{n}', steps.length - 1) : (q.dataset.doneLabel || 'Done'); }
    q.addEventListener('click', function (e) {
      var b = e.target.closest('.pf-q__opts button');
      if (b) {
        var st = b.closest('.pf-q__step'), k = steps.indexOf(st);
        ans[st.dataset.key] = { label: b.dataset.label || b.textContent.trim(), coll: b.dataset.coll || '', match: b.dataset.match || '' };
        $$('button', st).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        setTimeout(function () { show(k + 1); if (k + 1 === steps.length - 1) result(); }, 220);
      }
      if (e.target.closest('[data-qreset]')) { ans = {}; $$('.pf-q__opts button', q).forEach(function (x) { x.classList.remove('is-on'); }); show(0); }
    });
    function result() {
      var res = q.querySelector('[data-qres]'), sum = q.querySelector('[data-qsum]');
      var style = ans.style || {}, shape = ans.shape || {}, len = ans.length || {};
      try { localStorage.setItem('pf_fit', JSON.stringify({ shape: shape.label, length: len.label, style: style.label, t: Date.now() })); } catch (e) { }
      if (sum) sum.textContent = [shape.label, len.label, style.label].filter(Boolean).join(' · ');
      var coll = style.coll || shape.coll || q.dataset.fallback || 'all';
      res.innerHTML = '<p class="pf-muted">' + (q.dataset.loading || 'Finding your matches…') + '</p>';
      fetch('/collections/' + coll + '/products.json?limit=30').then(function (r) { return r.json(); }).then(function (j) {
        var all = (j.products || []).filter(function (p) { return p.variants.some(function (v) { return v.available !== false; }); });
        var m = function (p, s) { s = (s || '').toLowerCase(); if (!s) return true; return p.variants.some(function (v) { return [v.option1, v.option2, v.option3, v.title].join(' ').toLowerCase().indexOf(s) > -1; }) || (p.tags || []).join(' ').toLowerCase().indexOf(s) > -1 || p.title.toLowerCase().indexOf(s) > -1; };
        var both = all.filter(function (p) { return m(p, shape.match) && m(p, len.match); });
        var one = all.filter(function (p) { return m(p, shape.match) || m(p, len.match); });
        var list = []; [both, one, all].forEach(function (arr) { arr.forEach(function (p) { if (list.indexOf(p) === -1) list.push(p); }); });
        list = list.slice(0, parseInt(q.dataset.count, 10) || 3);
        if (!list.length) { res.innerHTML = '<p class="pf-muted">' + (q.dataset.empty || 'No match yet, browse all sets.') + '</p>'; return; }
        res.innerHTML = list.map(function (p) {
          var v = p.variants.filter(function (v) { return v.available !== false; })[0] || p.variants[0];
          var img = (p.images[1] && p.images[1].src) || (p.images[0] && p.images[0].src) || '';
          var price = PF.money(Math.round(parseFloat(v.price) * 100)), cmp = v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price) ? '<s>' + PF.money(Math.round(parseFloat(v.compare_at_price) * 100)) + '</s>' : '';
          var sizes = p.variants.filter(function (x) { return x.available !== false; }).map(function (x) { return '<button type="button" data-pf-variant="' + x.id + '">' + (x.option1 || x.title) + '</button>'; }).join('');
          return '<div class="pf-card"><a class="pf-card__media" href="/products/' + p.handle + '"><img class="is-main" src="' + PF.img(img, 600) + '" alt="" loading="lazy"><div class="pf-qa"><div class="pf-qa__t"><span>Choose size</span></div><div class="pf-qa__row">' + sizes + '</div></div></a><div class="pf-card__info"><a class="pf-card__name" href="/products/' + p.handle + '">' + p.title + '</a><div class="pf-price"><span class="pf-price__now">' + price + '</span>' + cmp + '</div><button type="button" class="pf-card__qa" data-pf-qa-open>' + (q.dataset.qaLabel || 'Choose size') + '</button></div></div>';
        }).join('');
      }).catch(function () { res.innerHTML = '<a class="pf-btn" href="/collections/' + coll + '">' + (q.dataset.browse || 'Browse the collection') + '</a>'; });
    }
    show(0);
  });

  /* ---------- popup with frequency control ---------- */
  $$('[data-pf-popup]').forEach(function (p) {
    var delay = (parseInt(p.dataset.delay, 10) || 0) * 1000, scrollPct = parseInt(p.dataset.scroll, 10) || 0, hideDays = parseInt(p.dataset.hideDays, 10) || 7, doneDays = parseInt(p.dataset.doneDays, 10) || 365;
    var now = Date.now(), ls = {};
    try { ls = JSON.parse(localStorage.getItem('pf_popup') || '{}'); } catch (e) { }
    var posted = /customer_posted=true/.test(location.search) && /#pf-popup/.test(location.hash + location.search);
    function store(k) { ls[k] = Date.now(); try { localStorage.setItem('pf_popup', JSON.stringify(ls)); } catch (e) { } }
    function open() { p.classList.add('is-open'); document.body.classList.add('pf-lock'); }
    function close() { p.classList.remove('is-open'); document.body.classList.remove('pf-lock'); store('closed'); }
    p.addEventListener('click', function (e) { if (e.target.closest('[data-pf-popup-close]') || e.target === p) close(); });
    var form = p.querySelector('form'); if (form) form.addEventListener('submit', function () { store('done'); });
    if (p.dataset.success === 'true' || posted) { store('done'); open(); return; }
    if (ls.done && now - ls.done < doneDays * 864e5) return;
    if (ls.closed && now - ls.closed < hideDays * 864e5) return;
    if (p.dataset.preview === 'true') { open(); return; }
    var fired = false; function fire() { if (fired) return; if (document.body.classList.contains('pf-lock')) { setTimeout(fire, 15000); return; } fired = true; open(); }
    if (delay) setTimeout(fire, delay);
    if (scrollPct) window.addEventListener('scroll', function onS() { var h = document.documentElement; if ((h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100 >= scrollPct) { fire(); window.removeEventListener('scroll', onS); } }, { passive: true });
    if (!delay && !scrollPct) setTimeout(fire, 15000);
  });

  /* ---------- remember "my fit" chip on collection ---------- */
  $$('[data-pf-fit]').forEach(function (el) {
    var fit = null; try { fit = JSON.parse(localStorage.getItem('pf_fit') || 'null'); } catch (e) { }
    if (!fit) { el.hidden = true; return; }
    var t = el.querySelector('[data-pf-fit-text]'); if (t) t.textContent = [fit.shape, fit.length, fit.style].filter(Boolean).join(' · ');
    el.hidden = false;
  });

  /* ---------- Shopify theme editor: re-init on section load ---------- */
  document.addEventListener('shopify:section:load', function () { $$('[data-pf-rotate]').forEach(function (r) { r.removeAttribute('data-pf-rotate'); }); });
})();
